import React from "react";
import { getErrorCopy } from "./errorCodes";
import "./InlineError.css";

/**
 * TIER 2: Inline component error.
 *
 * Use when ONE section of a page can't load but the rest works. Renders a
 * compact card with a short message and an optional retry button — sized
 * to fit inside the slot the broken section would have occupied.
 *
 * Don't use this for full-page failures (use ErrorScreen) or for
 * mutation-failure feedback (use showToast).
 *
 * Props:
 *   code     — error code for friendly copy
 *   title    — override
 *   message  — override
 *   onRetry  — if provided, renders a "Retry" button
 *   compact  — smaller padding for tight slots
 */
const InlineError = ({ code, title, message, onRetry, compact = false }) => {
  const defaults = getErrorCopy(code);
  return (
    <div className={`inline-error${compact ? " inline-error-compact" : ""}`} role="alert">
      <div className="inline-error-icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <div className="inline-error-body">
        <div className="inline-error-title">{title || defaults.title}</div>
        <div className="inline-error-message">{message || defaults.message}</div>
      </div>
      {onRetry && (
        <button type="button" className="inline-error-retry" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
};

export default React.memo(InlineError);
